import { Component } from '@angular/core';

@Component({
    selector: 'tree-indication',
    template: '<router-outlet></router-outlet>',
    standalone: false
})
export class TreeIndicationComponent {}
